import React from "react";
import { useNavigate } from "react-router-dom";
import "./StepHeader.css";

/* Application status banner — draft (incomplete) shows no message */
const STATUS_BANNERS = {
  new:          { text: "Your application is currently under review. Please wait for an update.", tone: "review", icon: "clock" },
  verified:     { text: "Your application is currently under review. Please wait for an update.", tone: "review", icon: "clock" },
  approved:     { text: "Your application is currently under review. Please wait for an update.", tone: "review", icon: "clock" },
  final_stage:  { text: "Congratulations! Your application has been approved and selected for the scholarship. Our team will contact you soon.", tone: "success", icon: "check" },
  rejected:     { text: "Your application was not selected for the scholarship this year. Please apply again next year.", tone: "rejected", icon: "x" },
  disqualified: { text: "Your application does not meet our eligibility criteria, so it has been disqualified. You are welcome to apply again next year.", tone: "disqualified", icon: "ban" },
};

const STATUS_ICONS = {
  clock: (<><circle cx="12" cy="12" r="9" /><path d="M12 7.5V12l3 2" /></>),
  check: (<><circle cx="12" cy="12" r="9" /><path d="M8.5 12.5l2.5 2.5 4.5-5" /></>),
  x:     (<><circle cx="12" cy="12" r="9" /><path d="M9.5 9.5l5 5M14.5 9.5l-5 5" /></>),
  ban:   (<><circle cx="12" cy="12" r="9" /><path d="M6 6l12 12" /></>),
};

/**
 * StepHeader — shows progress bar + step dots
 *
 * Props:
 *   steps   — array of { label, short, path }
 *   current — index of the current step (0-based)
 */
const StepHeader = ({ steps = [], current = 0 }) => {
  const navigate = useNavigate();
  const total = steps.length;
  const pct = total > 0 ? Math.round(((current + 1) / total) * 100) : 0;

  // application status banner (draft = no banner)
  const status = localStorage.getItem("application_status");
  const banner = STATUS_BANNERS[status];

  return (
    <div className="step-h">
      {/* title row */}
      <div className="step-h__head">
        <b>{steps[current]?.label || ""}</b>
        <span>Step {current + 1} of {total}</span>
      </div>

      {/* progress bar */}
      <div className="step-h__bar">
        <span className="step-h__bar-fill" style={{ width: `${pct}%` }} />
      </div>

      {/* step dots */}
      <nav className="step-h__dots" aria-label="Application steps">
        {steps.map((s, i) => {
          const cls = i === current ? "cur" : i < current ? "done" : "";
          return (
            <button
              key={i}
              className={`step-h__dot ${cls}`}
              onClick={() => s.path && navigate(s.path)}
              disabled={!s.path}
              title={s.label}
            >
              <i>{i + 1}</i>
              <em>{s.short || s.label}</em>
            </button>
          );
        })}
      </nav>

      {/* status banner */}
      {banner && (
        <div className={`step-h__status ${banner.tone}`}>
          <span className="step-h__status-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              {STATUS_ICONS[banner.icon]}
            </svg>
          </span>
          <span>{banner.text}</span>
        </div>
      )}
    </div>
  );
};

export default StepHeader;
